<template>
  <div class="hero-static">
    <div class="content forget-footer">
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6 col-xl-4">
          <div class="block block-themed block-fx-shadow mb-0">
            <div class="block-header">
              <h3 class="block-title">Reset your password</h3>
              <div class="block-options">
                <router-link class="btn-block-option js-tooltip-enabled" to="/login" title="Sign In">
                  <i class="fa fa-sign-in-alt"></i>
                </router-link>
              </div>
            </div>
            <div class="block-content">
              <div class="forget-content">
                <h1 class="mb-2">GrowTracker</h1>
                <p>Please provide your account’s email, and we will send you the link to reset your password.</p>
                <alert-message></alert-message>
                <form method="POST" name="forgot" v-on:submit.prevent>
                  <div class="form-group py-3">
                    <input type="text" class="form-control form-control-lg form-control-alt" id="userEmail" v-model="email" name="userEmail" placeholder="Email" v-validate="'required|verify_email'" data-vv-as="Email">
                    <p v-if="errors.has('userEmail')" class="forgetError">{{ errors.first('userEmail') }}</p>
                    <p v-if="errMsg" class="forgetError">{{ errMsg }}</p>
                  </div>
                  <div class="row">
                    <div class="col-md-12 col-xl-12 button-loader">
                      <button type="submit" v-bind:disabled="showLoader" class="btn btn-block btn-primary forgot-button" @click="process()">
                        <div><i class="fa fa-fw fa-envelope mr-1"></i><span> Send Mail</span></div>
                        <span v-if="showLoader" class="modal-loader">
                          <hash-loader class="custom-class text-white" color="#fff" loading="loading" size="20" sizeUnit="px"></hash-loader>
                        </span>  
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapActions } from 'vuex';
import VeeValidate from 'vee-validate';
import Footer from '@/components/Footer';
import AlertMessage from '@/components/AlertMessage';
import { VueSpinners } from '@saeris/vue-spinners';
import { HashLoader } from '@saeris/vue-spinners';
import { helper } from '@/helper.js';
Vue.use(VeeValidate, VueSpinners);

VeeValidate.Validator.extend('verify_email', {
  getMessage: field => 'Please enter a valid email.',
  validate: value => {
    var strongRegex = new RegExp('^[a-zA-Z0-9.!#$%&\'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$');
    return strongRegex.test(value);
  }
});
export default {
  name: 'forgotPassword',
  data : () => ({
    email: '',
    errMsg: '',
    showLoader: false
  }),
  components: {
    Footer,
    AlertMessage,
    HashLoader
  },
  methods: {
    ...mapActions('alert', ['success', 'error', 'clear']),
    process() {
      let vm = this;
      this.$validator.validate().then(valid => {
        if (valid) {
          vm.showLoader = true;
          helper.sendPostRequest('/login/forgotpassword',
            {'email': vm.email},
            { headers: vm.getAuthHeader() }
          ).then(function(data) {
            if (data.status === 'success') {
              vm.success(data.message);
              vm.email = '';
              vm.showLoader = false;
              vm.$validator.reset();
            } else {
              vm.showLoader = false;
              vm.error(data.message);
            }
            vm.handleAlertMessage();
          }).catch(function() {
            vm.showLoader = false;
            vm.error('Unable to process your request, Please try again later.');
            vm.handleAlertMessage();
          });
        }
      });
    },
    handleAlertMessage() {
      let vm = this;
      setTimeout(() => { vm.clear();}, 5000);
    }
  },
  beforeDestroy() {
    this.clear();
  }
};
</script>

<style>
.forget-content {
  padding: 1rem;
}
.forget-footer {
  min-height: calc(100vh - 61px);
  padding-bottom: 2rem;    
}
.forgetError {
  font-size: 0.7rem;
  color: red;
  padding-top: 5px;
  margin-bottom: 0 !important;
}
.forgot-button {
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// source/components/ForgotPassword.vue